import { storage } from '@itau-loans-www/utils'

export default () => {
  storage.session.setItem('token', JSON.stringify(null))
}
